module.exports = __webpack_public_path__ + "static/img/bgTask.cf75dab.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dailyFreeCash/bgTask.webp
// module id = 6RS9
// module chunks = 0